import React from "react";
import "./style.scss";

const CustomForm = ({ children }) => {
  return <div className="customform-root">{children}</div>;
};
export default CustomForm;
